@for (item of menuItemsList; track item) {
  <div class="mc-nav-menu">
    <ng-container *permissionGuard="item.permission">
      @if (item.menuItems) {
        <expansion-panel-nav-item
          class="mc-nav-menu__exp-panel"
          [ngClass]="{active: isActiveNavLink(item)}"
          [panelNavItem]="item"
          [currentRoute]="currentRoute"
          (keydown.enter)="goToMenuItem(item)"
          [isActive]="isActiveNavLink(item)"
          [navItem]="item"
          (navigate)="menuItemClick(item)"
        >
          <mc-nav-menu class="mc-nav-menu__exp-panel_menu-item" body [menuItems]="item.menuItems"></mc-nav-menu>
        </expansion-panel-nav-item>
      } @else {
        <mc-nav-item
          [isActive]="isActiveNavLink(item)"
          [label]="item.label | translate"
          [icon]="item.icon"
          [iconActive]="item.iconActive"
          [labelIcon]="item.labelIcon"
          [labelIconActive]="item.labelIconActive"
          [link]="item.routerLink"
          (click)="menuItemClick(item)"
          [walkThroughStep]="item.intro ?? null"
        >
        </mc-nav-item>
      }
    </ng-container>
  </div>
}
